/** Tiny class-name joiner (no dependency, same helper as `@akpl/ui-tv`). */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
